export interface AuditTurbine {
  id: string;
  name?: string;
  subType?: string;
}

export interface AuditLocation {
  id: string;
  title: string;
  subtitle?: string;
  timezone: string;
  turbines: AuditTurbine[];
}

export interface AuditRow {
  id: string;
  turbine: string;
  date: string;
  timezone: string;
  fuelData: number | null;
  engineFiredHours: number | null;
  monthlyStarts: number | null;
  monthlyStops: number | null;
}

export interface AuditColumnSelection {
  showFuel: boolean;
  showEngineHours: boolean;
  showMonthlyStarts: boolean;
  showMonthlyStops: boolean;
}

export interface AuditDateRange {
  start: string;
  end: string;
}

export const turbineSelectionKey = (
  locationId: string,
  turbineId: string
): string => `${locationId}/${turbineId}`;
